<template>
  <overview-layout ref="overview" :tableCfg="tableCfg">
    <template slot="AdvancedFilter">
      <b-form ref="form" class="offset-md-1" autocomplete="off">
        <div class="row">
          <!-- <detail-field label="Student" field="student_id" :optionListApiUrl="'/students/choice/'" :rec="searchRec" vvalidate="ok" @enter="doFilter" :validator="validator"/> -->
          <detail-field class="col-md-4" label="Contract/Student" field="contract_id" :optionListApiUrl="'/contracts/choice/'" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field label="Email Sent" field="email_sent" :optionList="boolFilterOptions" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
          <detail-field class="col-md-4" label="Payment date after" type="date" field="payment_after" :rec="searchRec" vvalidate="ok" :validator="validator" @enter="doFilter"/>
        </div>
      </b-form>
    </template>
    <template slot="ExtraOptions" scope="props">
        <b-dropdown  variant="default" size="sm">
          <template slot="button-content"> <i class="fa fa-cog"></i> </template>
          <b-dropdown-item @click="exportSelection('/invoice_payments/download_report', 'Invoices_payments.xlsx')">Export Selection</b-dropdown-item>
        </b-dropdown>
        <b-dropdown v-if="hasSelections() && privUser" variant="default" size="sm">
          <template slot="button-content">
              <i class="fa fa-rocket"></i> Batch
          </template>
          <b-dropdown-item @click="$refs.overview.runBatch(sendEmail, 'id')">Send Payment Confirmation</b-dropdown-item>
        </b-dropdown>
    </template>
  </overview-layout>
</template>

<script>
import OverviewMixin from '../../components/OverviewMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'invoice_overview',
  mixins: [OverviewMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
    sendEmail (id, okFnc, errorFnc) {
      this.api.post('/invoice_payments/' + id + '/send_email', {}, okFnc, errorFnc, this.$refs.overview.alert)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Overview.vue?581178ed